import { GridController, gridTpl } from '../../../../../common/grid/grid.controller';
import { IDS } from '../pnp-doc.constants';
import { getDocument, getDocumentHistory } from '../pnp-doc.actions';
import { TAB_HIDE } from '../../../../../common/tabs/tabs.constants';

class pnpDocumentHistoryGridController extends GridController {
    /* @ngInject */
    constructor($ngRedux, $state, NavigationService, $filter, $mdDialog, $scope, $rootScope, AuthService) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.AuthService = AuthService;
    }

    $onInit() {
        this.module = 'policies';
        this.identifier = IDS.pnpDocumentHistoryGrid;
        this.filterExpandButtonVisible = false;

        this.columns = [
            { title: '#', mapper: 'docNum' },
            { title: 'Version', mapper: 'version' },
            { title: 'Title', mapper: 'title' },
            { title: 'Document Type', mapper: 'documentType' },
            { title: 'Author', mapper: 'author' },
            { title: 'Created Date', mapper: 'created_date' },
            { title: 'Status', mapper: 'docStatus' }
        ];

        this.unsubscribe = this.$ngRedux.connect(
            this.mapState().bind(this),
            { getDocumentHistory }
        )(this);

        this.buttons = [{
            class: 'btnGridAction',
            label: 'View',
            callback: event => {
                this.onSelect(event)
            },
            filter: item => {
                return item
            }
        }, {
            class: 'btnGridAction',
            label: 'Download',
            callback: event => {
                this.onDownload(event)
            },
            filter: item => {
                return item.downloadAllowed ? item.path : null;
            }
        }];

        this.filter.identifier = this.identifier;
        this.dataAction = this.getDocumentHistory;
        this.exportService = this.getDocumentHistory;

        this.buttonsDefault = this.buttons.concat();
    }


    $onDestroy() {
        this.destroy();
    }
}


pnpDocumentHistoryGridController.$inject = ['$ngRedux', '$state', 'NavigationService', '$filter', '$mdDialog', '$scope', '$rootScope'];

export const pnpDocumentHistoryGrid = {
    bindings: {
        title: '@',
        onSelect: '&',
        onDownload: '&',
        onRemove: '&',
        onReset: '&'
    },
    controller: pnpDocumentHistoryGridController,
    ...gridTpl
}
